/* cc-price-per-unit — recompute "$X.XX each" on Dawn's variantChange.
   Units parsed from option values: "Case (21)" / "28 Units". */

(() => {
  const root = document.querySelector('[data-cc-ppu]');
  if (!root) return;
  const valueEl = root.querySelector('[data-cc-ppu-value]');

  const unitsFrom = (options) => {
    for (const opt of options || []) {
      let m = /case\s*\((\d+)\)/i.exec(opt);
      if (m) return parseInt(m[1], 10);
      m = /^(\d+)\s*units?\b/i.exec(opt);
      if (m) return parseInt(m[1], 10);
    }
    return 1;
  };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const update = (variant) => {
    const units = unitsFrom(variant?.options);
    if (!variant || units < 2) {
      root.hidden = true;
      return;
    }
    valueEl.textContent = `${money(Math.floor(variant.price / units))} each`;
    root.hidden = false;
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (e) => update(e.data.variant));
  }
})();
